// OWASP Top 10 for LLM Applications, 2025 (v2.0). `checked` reflects whether
// src/services/securityAnalysis.ts actually has a detection pattern tagged
// with that category — see the retagging table in Task 2 and completeness sweep
// in Task 12 of docs/superpowers/plans/2026-08-05-compliance-owasp-llm-accuracy.md.
// Keep this list in sync by hand if that tagging ever changes.
//
// LLM09 (Misinformation): hallucination detection requires dynamic evaluation
// (LLM-as-a-judge, semantic entropy, RAG-faithfulness scoring). However, a
// static code signal exists for the *risk context*: AI used in medical/legal/
// financial domains without a human review gate (llm09-high-stakes-domain
// pattern in securityAnalysis.ts). Checked as a partial/risk-indicator signal.
export interface OwaspLlmChecklistItem {
  id: string;
  label: string;
  checked: boolean;
}

export const OWASP_LLM_TOP_10: OwaspLlmChecklistItem[] = [
  { id: 'LLM01', label: 'Prompt Injection', checked: true },
  { id: 'LLM02', label: 'Sensitive Information Disclosure', checked: true },
  { id: 'LLM03', label: 'Supply Chain', checked: true },
  { id: 'LLM04', label: 'Data and Model Poisoning', checked: true },
  { id: 'LLM05', label: 'Improper Output Handling', checked: true },
  { id: 'LLM06', label: 'Excessive Agency', checked: true },
  { id: 'LLM07', label: 'System Prompt Leakage', checked: true },
  { id: 'LLM08', label: 'Vector and Embedding Weaknesses', checked: true },
  { id: 'LLM09', label: 'Misinformation', checked: true },
  { id: 'LLM10', label: 'Unbounded Consumption', checked: true },
];

export const OWASP_LLM_CHECKED_COUNT = OWASP_LLM_TOP_10.filter(i => i.checked).length;
